import { api } from '../../plugins/axios';

export class ReportsModuleService {
	static getVariantPriceReport(params) {
		return api
			.get('/main-order/reports/variant-price-report', {
				params,
			})
			.then((res) => ({ data: res.data.result.data, totalRecords: res.data.result.total }));
	}
	static getVariantSalesReport(params) {
		return api
			.get('/main-order/reports/variant-sales-report', {
				params,
			})
			.then((res) => ({ data: res.data.result.data, totalRecords: res.data.result.total }));
	}

	static getOrdersReturnsReport(params) {
		return api
			.get('/main-order/reports/return-order-report', {
				params,
			})
			.then((res) => ({ data: res.data.result.data, totalRecords: res.data.result.total }));
	}
	static getProductsAlertsReport(params) {
		return api
			.get('/main-order/reports/product-alert-report', {
				params,
			})
			.then((res) => ({ data: res.data.result.data, totalRecords: res.data.result.total }));
	}

	static getLinkedVariantsReport(params) {
		return api
			.get('/products/reports/linked-variants-report', {
				params,
			})
			.then((res) => ({ data: res.data.result.data, totalRecords: res.data.result.total }));
	}

	static getLinkedVariantsMarketplaces() {
		return api
			.get('/products/reports/linked-variants-marketplaces')
			.then((res) => res.data.result);
	}

	static getPricingLog(params) {
		return api
			.get('/products/price-log', {
				params,
			})
			.then((res) => ({
				data: res.data.result.logs.data,
				totalRecords: res.data.result.logs.total,
			}));
	}
	static getTrendyolLog(params) {
		return api
			.get('/trendyol/trendyol-request-log', {
				params,
			})
			.then((res) => ({
				data: res.data.result.trendyol_request_logs.data,
				totalRecords: res.data.result.trendyol_request_logs.total,
			}));
	}
	static getNoonLog(params) {
		return api
			.get('/noon/noon-request-log', {
				params,
			})
			.then((res) => ({
				data: res.data.result.noon_request_logs.data,
				totalRecords: res.data.result.noon_request_logs.total,
			}));
	}
	static getFbaInventoryReport(params) {
		return api
			.get('/main-order/reports/fba-inventory-report', {
				params,
			})
			.then((res) => ({
				data: res.data.result.data,
				totalRecords: res.data.result.total,
				summary: res.data.result.summary,
			}));
	}
	static requestFbaInventoryReport() {
		return api.post('/main-order/reports/fba-inventory-report/request');
	}

	static getActivityLog(params) {
		return api.get('/tenant/activity-logs', { params }).then((res) => ({
			data: res.data.result.data,
			totalRecords: res.data.result.total,
		}));
	}
	static getTransactionsHistory(params) {
		return api.get('/my-fatoorah/transactions', { params }).then(({ data }) => ({
			data: data.result.invoices.data,
			totalRecords: data.result.invoices.total,
		}));
	}
	static getSupplierBalance() {
		return api.get('/my-fatoorah/supplier-balance').then(({ data }) => data.result);
	}
}
